export default function sanitizeString(line){
    const whitespace = new RegExp("\\s", "g")
    let _line = line.normalize("NFD")
    _line = _line.replace(/[\u0300-\u036f]/g, "")
    _line = _line.replace(whitespace, '_')
    return _line.toLowerCase()
  }